export default "__VITE_ASSET__DzYTgoHW__"